import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {Subject} from 'rxjs/Subject';
import {Agency} from '../../@models/agency.model';
import {AgencyDBService} from '../../@db/agency-db.service';

@Injectable()
export class AgencyFieldService {
  agencyString = new Subject<string>();

  selectedAgencyPk = new ReplaySubject<number>(1);
  selectedAgency = this.selectedAgencyPk.switchMap(pk => this.api.get(pk));

  agencySearchTerm = this.agencyString
    .map(s => s.trim())
    .debounceTime(200)
    .distinctUntilChanged();
  agencyChoices = this.agencySearchTerm
    .startWith('')
    .switchMap(keywords => {
      if (keywords.length >= 3) {
        return this.api.search(keywords, 7).toArray();
      } else {
        return Observable.empty();
      }
    })
    .shareReplay(1);

  chosenAgency: Observable<Agency.Model> = Observable
    .merge(this.agencySearchTerm.map(() => null), this.selectedAgency.debounceTime(300))
    .shareReplay(1);

  constructor(private api: AgencyDBService) {
  }
}
